










import Vue from 'vue';
import Component from 'vue-class-component';
import MIcon from '../../index';

Vue.use(MIcon);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  // TODO
}
